import React, { useState, useEffect, useRef } from 'react'
import PageContainer from '../../components/PageContainer'
import { PageHeader } from '../../components/Layout/PageHeader'
import { Box, } from '@mui/system'
import { Typography, Stack,  } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom'
import InstallerLookup from '../../components/Installer/InstallerLookup/InstallerLookup'
import { InstallerDetailsDialog } from "../../pages/Installer/InstallerDetailsDialog";
import { InstallerService } from '../../services/DataService'
import { Translate, translate } from 'react-i18nify';
import TimeUtils from '../../utils/TimeUtils'
import SyncIcon from '@mui/icons-material/Sync';
import BuildIcon from '@mui/icons-material/Build';
import { UserService } from '../../services/DataService'
import { UpdatesBanner } from "../../components/UpdatesBanner";

export default function InstallerOverview() {

    const navigate = useNavigate();
    const [searched, setSearched] = useState(false);
    const [loading, setLoading] = useState(true);
    const [overviewData, setOverviewData] = useState([]);
    const [overviewDataSearched, setOverviewDataSearched] = useState([]);
    const [requestFailed, setRequestFailed] = useState({code: 0, text: ""});

    const [installerDetailsDialogOpen, setInstallerDetailsDialogOpen] = useState(false);
    const [patientDeviceData, setPatientDeviceData] = useState([]);
    const [isO2maticUser, setIsO2maticUser] = useState(false);
    const [loadingO2maticUser, setLoadingO2maticUser] = useState(true);
    const [remarks, setRemarks] = useState([
        {id: 0, filtered: false, name: "NewPatient", value: "NewPatient", explainer: "RemarkExplainers.NewPatient.Explainer", recommendedAction: "RemarkExplainers.NewPatient.RecommendedAction" },
        {id: 1, filtered: false, name: "PatientUnauthorized", value: "PatientUnauthorized", explainer: "RemarkExplainers.PatientUnauthorized.Explainer", recommendedAction: "" },
        {id: 2, filtered: false, name: "DeviceUnauthorized", value: "DeviceUnauthorized", explainer: "RemarkExplainers.DeviceUnauthorized.Explainer", recommendedAction: "" },
        {id: 3, filtered: false, name: "LocationMismatch", value: "LocationMismatch", explainer: "RemarkExplainers.LocationMismatch.Explainer", recommendedAction:"RemarkExplainers.LocationMismatch.RecommendedAction" },
        {id: 4, filtered: false, name: "NoSessionDataSinceDaysName", value: "NoSessionDataSinceDays", explainer: "RemarkExplainers.NoSessionDataSinceDays.Explainer", recommendedAction:"RemarkExplainers.NoSessionDataSinceDays.RecommendedAction" }, // this one is hardcoded below so if ID is changed, change it here too
        {id: 5, filtered: false, name: "PatientDeleted", value: "PatientDeleted", explainer: "RemarkExplainers.PatientDeleted.Explainer", recommendedAction:"RemarkExplainers.PatientDeleted.RecommendedAction" },
        {id: 6, filtered: false, name: "NoData", value: "NoData", explainer: "RemarkExplainers.NoData.Explainer", recommendedAction:"RemarkExplainers.NoData.RecommendedAction" },
        {id: 7, filtered: false, name: "PatientUnpaired", value: "PatientUnpaired", explainer: "RemarkExplainers.PatientUnpaired.Explainer", recommendedAction:"RemarkExplainers.PatientUnpaired.RecommendedAction" },
        {id: 8, filtered: false, name: "NewTreatment", value: "NewTreatment", explainer: "RemarkExplainers.NewTreatment.Explainer", recommendedAction:"RemarkExplainers.NewTreatment.RecommendedAction" },
        {id: 9, filtered: false, name: "OK", value: "OK", explainer: "RemarkExplainers.OK.Explainer", recommendedAction: "" },
        {id: 10, filtered: false, name: "NoPatientOnDevice", value: "NoPatientOnDevice", explainer: "RemarkExplainers.NoPatientOnDevice.Explainer", recommendedAction: "" },
    ])
    const [updateOptions, setUpdateOptions] = useState([
        {id: 0, filtered: false, name: "SWUpdate", value: translate("UpdateFilters.SWUpdateAvailable") },
        {id: 1, filtered: false, name: "Service", value: translate("UpdateFilters.ServiceAvailable") },
        {id: 2, filtered: false, name: "DeviceIsUpToDate", value: translate("UpdateFilters.DeviceIsUpToDate") },
    ])

    const [hiddenColums, setHiddenColums] = useState({location: false});
    const [filteredOverview, setFilteredOverview] = useState([]);
    const [dfu, setDfu] = useState(null);

    const abortControllerRef = useRef(null);

    const isNotAuthorizedStates = {
        0: "PATIENT", //Component is not on the same heirarchy as the patient
        1: "COMPONENT", //Patient is not on the same heirarchy as the component
        2: "ALLOW", //The pairing is allowed to see each other
        3: "NOLINK", //There is not paring/link between the component and an patient
    }


    const queryInstaller = (query) => {
        if(abortControllerRef.current !== null){
            abortControllerRef.current.abort();
        }

        setLoading(true);

        if(Object.keys(query).length <= 0){
            setLoading(false)
            return;
        }
        setRequestFailed({code: 0, text: ""})
        setFilteredOverview([]);
        setOverviewData([])

        var queryString = "";

        for (var key in query) {
            if (query.hasOwnProperty(key)) {
                queryString += key + "=" + query[key] + "&"
            }
        }
        queryString = queryString.slice(0, -1); // remove last &

        (async () => {
            await InstallerService.getOvervieSearch(queryString).then((apiResult) => {
                const overviewDataSearched = apiResult.data.map((row, index) => ({
                    id: index + 1, // Adding ID starting from 1
                    remark: getPatientStatus(row),
                    ...row,
                  }));;
                const sortedOverview = overviewDataSearched.sort((a, b) => a.remark.id - b.remark.id); // sort by remark id (0-7)
                setOverviewDataSearched(sortedOverview);
                enableFilters(sortedOverview)
            }).catch((error) => {
                setOverviewData([]);
                setOverviewDataSearched([])
                setFilteredOverview([])
                setRequestFailed({code: error.response.status, text: "No results from search."})
                console.log(error)
            }).finally(() => {
                setOverviewData([])
                setLoading(false);
            })
        })();
        setSearched(true)
    }

    const goToInstallerDetails = (params, event) => {
        let row = params.row;
        setPatientDeviceData(row);
        setInstallerDetailsDialogOpen(true);
    };

    const getUserLocation = () => {
        (async () => {
            await UserService.getActiveUserLocation().then(response => {
                const location = response.data;
                if(process.env.REACT_APP_ENV === ""){
                    setIsO2maticUser(location.id === 21)
                }

            }).catch(e => {
                console.error(e)
            }).finally(() => {
                setLoadingO2maticUser(false)
            })
        })();
    }


    const getOverview = (newSearchValue) => {
        setRequestFailed({code: 0, text: ""})
        setFilteredOverview([]);
        setOverviewData([])
        setOverviewDataSearched([])
        setLoading(true);
        setSearched(newSearchValue);
        var abortController = new AbortController()
        abortControllerRef.current = abortController;
        (async () => {
            await InstallerService.getOverview(abortControllerRef.current).then((response) => {
                if(abortControllerRef.current.signal.aborted) 
                    return; // check if the request was aborted
                
                const newOverviewData = response.data.map((row, index) => ({
                    id: index + 1, // Adding ID starting from 1
                    remark:  getPatientStatus(row),
                    ...row,
                }));;
                const sortedOverview = newOverviewData.sort((a, b) => a.remark.id - b.remark.id); // sort by remark id (0-7)
                setOverviewData(sortedOverview);
                enableFilters(sortedOverview);
            }).catch((err) => {
                console.log(err)
                setRequestFailed({code: err.response.status, text: "No results from search."})
            }).finally(() => {
                setLoading(false);
            })
        })();
    }
    useEffect(() => {
        getOverview(false);
        getUserLocation();
    },[])

    useEffect(() => {
        searched ? enableFilters(overviewDataSearched) : enableFilters(overviewData)
    },[remarks, dfu, updateOptions])

    // useEffect(() => {
    //     let toHide = {location: false}
    //     setHiddenColums(toHide)
    // },[searched])

    const enableFilters = (dataToFilter) => {
        const remarkFilters = remarks.filter(remark => remark.filtered === true);
        const updateOptionsFilters = updateOptions.filter(option => option.filtered === true);
        let filteredData = [];
        filteredData = FilterOutDeletedPatientWithNoComponent(dataToFilter)
        // filteredData = dataToFilter
        if(remarkFilters.length > 0){
            const fitlerNames = remarkFilters.map(remark => remark.name)
            filteredData = filteredData.filter(row => fitlerNames.includes(row.remark.name));
        }
        if(updateOptionsFilters.length > 0){
            filteredData = updateOptionsFiltering(filteredData, updateOptionsFilters)
        }
        setFilteredOverview(filteredData);
    }

    const updateOptionsFiltering = (dataToFilter, updateOptionsFilters) => {
        let filteredData = []
        updateOptionsFilters.forEach(filter => {
            switch(filter.name){
                case "SWUpdate":
                    filteredData = [...filteredData, ...dataToFilter.filter(row => 
                        row.component != null && 
                        row.component?.metaData?.find(x => x.metadataId === 14)?.value !== row.latestSoftware?.find(x => x.metadataId === 14)?.value
                    )]
                    break;

                case "FWUpdate":
                    filteredData = [...filteredData,  ...dataToFilter.filter(row => 
                        row.component != null && 
                        row.component?.metaData?.find(x => x.metadataId === 15)?.value !== row.latestSoftware?.find(x => x.metadataId === 15)?.value
                    )]
                    break;
                
                case "DeviceIsUpToDate": 
                    filteredData = [...filteredData,  ...dataToFilter.filter(row => 
                        row.component != null && 
                        row.component?.metaData?.find(x => x.metadataId === 14)?.value === row.latestSoftware?.find(x => x.metadataId === 14)?.value &&
                        row.component?.metaData?.find(x => x.metadataId === 15)?.value === row.latestSoftware?.find(x => x.metadataId === 15)?.value
                    )]
                    break;
            }
        })
        return filteredData
    }

    const FilterOutDeletedPatientWithNoComponent = (dataToFilter) => {
        const newArray = dataToFilter.filter(row => {
            if(row.patient?.deleted == null /*&& row.patient?.created != null*/){ // double check if this should be there. old patients might not have this field in db
                return row
            }else if(row.patient?.deleted != null){
                if(row.patient?.componentLink != null && row.patient?.componentLink?.end == null){
                    return row
                }
            }else if(row.component != null && row.patientId == null){
                return row;
            }
        })
        return newArray;
    }

    const getPatientStatus = (row) => {
        try{
            let noPatientOnDevice = row.component != null && row.patientId == null;
            let unAuthorizedLink = isNotAuthorizedStates[row.isNotAuthorized]

            // Does device have patient paired?
            if (noPatientOnDevice == true) {
                if (unAuthorizedLink === isNotAuthorizedStates[0]){//Is the patient unauthorized?
                    return remarks.filter(remark => remark.name === "PatientUnauthorized")[0]
                } 

                return remarks.filter(remark => remark.name === "NoPatientOnDevice")[0];

            } else { // device is paired!
                let patientNotPaired = row.component == null && row.patientId != null;
                let patientUnpaired = row.patient?.componentLink?.end != null ? true : false; 
                let deleted = row.patient?.deleted != null ? true : false;
                let treatmentUpToDate = row.prescribedTreatment?.treatmentId == row.currentTreatment?.treatmentId;
                let no_data = row.lastReceivedData == null ? true : false; // no data = no sessions & no detailed data
                let lastSessionTimestamp = (no_data == true) ? null : row.lastReceivedData.find(d => d.dataType === 0).timestamp;

                let sessions_old = (lastSessionTimestamp == null) ? false : (TimeUtils.getAmountOfDaysBetween(TimeUtils.utcToLocalDate(lastSessionTimestamp),new Date()) >= 1 ) ? true : false; // check if data is older than 24 hours
                let locationMismatch = row.patient.location.id === row.component?.location.id

                // Has patient been deleted?
                if (deleted == true) {
                    return remarks.filter(remark => remark.name === "PatientDeleted")[0]; // patient is deleted!

                } else if(unAuthorizedLink === isNotAuthorizedStates[1]) { //user is not allowed to see device paired with patient
                    return remarks.filter(remark => remark.name === "DeviceUnauthorized")[0]     

                } else if (patientNotPaired == true) {// Has patient been unpaired?
                    return remarks.filter(remark => remark.name === "NewPatient")[0]; // patient is not paired and has no previous pairing with a device (new patient)!

                } else if (patientUnpaired == true) { // Has the patient previously been paired to a device?
                    row.component = null; //Dont show the component if it is not the active component.
                    return remarks.filter(remark => remark.name === "PatientUnpaired")[0]; // patient has been unpaired!

                } else if (locationMismatch === false){
                    return remarks.filter(remark => remark.name === "LocationMismatch")[0]; // patient and component doesn't have the same location but the user is allowed to see both
                
                } else if (treatmentUpToDate == false) { // patient is still paired!
                    return remarks.filter(remark => remark.name === "NewTreatment")[0]; // latest treatment is not installed (new treatment)!

                    // Is there any data (checks both session and detailed data)?
                } else if (no_data == true) { // no data!
                    return remarks.filter(remark => remark.name === "NoData")[0]; // no data!
                    // Is data older than 24 hours?
                } else if (sessions_old == true) { // patient is active!
                    return {id: 1, name: "NoSessionDataSinceDaysName", value: translate("NoSessionDataSinceDays", {days: TimeUtils.getAmountOfDaysBetween(TimeUtils.utcToLocalDate(lastSessionTimestamp),new Date())}) } // data is older than 24 hours! // no data since {timestamp}

                } else {
                    return remarks.filter(remark => remark.name === "OK")[0]; //No other remarks

                }
            }
        }catch(err){
            console.error(err)
        }
    }



    const allColumns = [
        {
            field: 'o2maticID', headerName: translate('O2maticId'), flex: 1, minWidth: 70, maxWidth:100, 
            valueGetter: (params) => {
                let row = params.row;
                let id = row.patientId;
                if (id == null) {
                    return "-" //"no patient on device";
                } else {
                    return id;
                }
            }
        },        
        {
            field: 'location', headerName: translate('Location'), flex: 1, minWidth: 70, maxWidth:100, 
            valueGetter: (params) => {
                let row = params.row;
                if(row.patient != null)
                    return row.patient.location.name
                else if(row.component != null)
                    return row.component.location.name
                else
                    return "-"
            }
        },
        {
            field: 'remark', headerName: translate('Remark'), flex: 2, 
            valueGetter: (params) => {
                return translate(params.row.remark.value)
            },
        },
        {
            field: 'O2FlowRange', headerName: translate('O2FlowRange'), flex:2, minWidth: 70, maxWidth:150,
            valueGetter: (params) => {
                let row = params.row;
                let treatmentValues = row.prescribedTreatment?.treatmentValues;
                if(treatmentValues){
                    return `${treatmentValues.find(tv => tv.code == "LO2ST").value} - ${treatmentValues.find(tv => tv.code == "HO2ST").value} l/min`;
                }
                else{
                    return "-"
                } 
            }
        },
        //         Missing implementation until it has been added to
        {
            field: 'backupFlow', headerName: translate('BackupFlow'), flex: 2, minWidth: 70, maxWidth:150, 
            valueGetter: (params) => {
        
                let row = params.row;
                let iBackupFlowValue = row.prescribedTreatment?.treatmentValues?.find(tv => tv.code == "IBF");
                if(iBackupFlowValue){
                    return `${iBackupFlowValue.value} l/min`
                }
                return "-"

            }
        },
        {
            field: 'hasWifi', headerName: translate('Wifi'), flex: 1, minWidth: 70, 
            valueGetter: (params) => {
                let row = params.row;
                if(row.patient == null)
                    return "-"
                if(row.patient?.hasWifi === true){
                    return translate("Yes")
                }
                else if(row.patient?.hasWifi === false){
                    return translate("No")
                }
                else if(row.patient?.hasWifi == null){
                    return translate("Unknown")
                }
            }
        },
        {
            field: 'udsn', headerName: translate("UDSN"), minWidth:150,
            valueGetter: (params) => {
                if (params.row.component == null) { // what if the device is not paired but there is a component
                    return "-" //"Patient not paired to a device";
                } else {
                    return params.row.component?.metaData?.find(x => x.metadataId === 1)?.value;
                }

                
            }
        },
        {
            field: 'SWVersion', headerName: translate("Software"), minWidth: 80, maxWidth: 100, flex: 1, 
            renderCell: (params) => {
                const deviceSw = params.row.component?.metaData?.find(x => x.metadataId === 14)?.value
                if (params.row.component == null) { // what if the device is not paired but there is a component
                    return  <span>{"-"}</span>  //"Patient not paired to a device";
                } else if(deviceSw == null){
                    return (
                        <span>{translate("Unknown")}</span>
                    ) 
                } else if (params.row.latestSoftware?.find(x => x.metadataId == 14)?.value != deviceSw) {
                    return(
                        <Box sx={{ width:"100%", justifyContent: 'space-between', display: "flex", flexDirection: "row"}} >
                        <Box sx={{ }}>
                            <span>{deviceSw}</span>
                        </Box>
                        <SyncIcon/>
                    </Box>

                    )
                } else {
                    return deviceSw;
                }
            }
        },
        {
            field: 'FWVersion', headerName: translate("Firmware"), minWidth: 80, maxWidth: 100, flex: 1, 
            renderCell: (params) => {
                const deviceFw = params.row.component?.metaData?.find(x => x.metadataId === 15)?.value
                if (params.row.component == null) { // what if the device is not paired but there is a component
                    return (
                        <span>{"-"}</span>
                    ) 
                } else if(deviceFw == null){
                    return (
                        <span>{translate("Unknown")}</span>
                    )
                } else if (params.row.latestSoftware?.find(x => x.metadataId == 15)?.value != deviceFw) {
                    return (
                        <Box sx={{ width:"100%", justifyContent: 'space-between', display: "flex", flexDirection: "row"}} >
                            <Box sx={{ }}>
                                <span>{deviceFw}</span>
                            </Box>
                            <BuildIcon/>

                        </Box>
                    )
                } else {
                    return <span>{deviceFw}</span>;
                }

            }
        },        
        {
            field: 'name', headerName: translate('Name'), flex: 2, minWidth: 70,
            valueGetter: (params) => {
                let row = params.row;
                if (row?.patient?.patient?.name === undefined) {
                    return "n/a";
                }
                let names = row?.patient.patient?.name[0]?.given.length > 0 ? row?.patient?.patient?.name[0].given : "n/a";
                let result = "";
                names.forEach(item => {
                    result += item.value;
                });
                result += ` ${row.patient.patient?.name[0].family.value}`;
                return result;
            }
        },
        {
            field: 'address', headerName: translate('Address'), flex: 2, 
            valueGetter: (params) => {
                let row = params.row;
                let address = ""
                row.patient.patient?.address.forEach(item => {
                    address = `${item.line[0].value}, ${item.postalCode.value} ${item.city.value}, ${item.country.value}`    
                })
                return address;
            }
            
        },

    ]

    const defaultColumns = [
        allColumns.find(c => c.field === "o2maticID"),
        allColumns.find(c => c.field === "location"),
        allColumns.find(c => c.field === "remark"),
        allColumns.find(c => c.field === "O2FlowRange"),
        allColumns.find(c => c.field === "backupFlow"),
        allColumns.find(c => c.field === "hasWifi"),
        allColumns.find(c => c.field === "SWVersion"),
        allColumns.find(c => c.field === "FWVersion"),
        allColumns.find(c => c.field === "udsn"),
    ]

    const searchedColums = [
        allColumns.find(c => c.field === "o2maticID"),
        allColumns.find(c => c.field === "name"),
        allColumns.find(c => c.field === "address"),
        allColumns.find(c => c.field === "location"),
        allColumns.find(c => c.field === "remark"),
        allColumns.find(c => c.field === "O2FlowRange"),
        allColumns.find(c => c.field === "backupFlow"),
        allColumns.find(c => c.field === "hasWifi"),
        allColumns.find(c => c.field === "SWVersion"),
        allColumns.find(c => c.field === "FWVersion"),
        allColumns.find(c => c.field === "udsn"),

    ]

    return (
        <PageContainer >
            <InstallerDetailsDialog
                open={installerDetailsDialogOpen}
                onClose={()=>setInstallerDetailsDialogOpen(false)}
                data={patientDeviceData}
            ></InstallerDetailsDialog>


            <PageHeader leftAlign><Translate value="Installer" /></PageHeader>

            <UpdatesBanner update_description="UpdatesDescriptionInstallerPage"/>

            <Box sx={{mt:-3, width: { xs: "100%", sm: "100%", md: "100%", lg: "1500px" }, maxWidth: {md: "2000px"} }}>
                <Box sx={{display:"flex", flexDirection:"row", justifyContent: 'space-between', mb:4 }}>
                </Box>
                <InstallerLookup 
                    handleSearchQuery={queryInstaller} 
                    remarks={remarks} 
                    setRemarks={setRemarks}
                    dfu={dfu} 
                    setDfu={setDfu}
                    updateOptions={updateOptions}
                    setUpdateOptions={setUpdateOptions}
                    getOverview={getOverview}
                    loadingIsO2maticUser={loadingO2maticUser}
                    isO2maticUser={isO2maticUser}
                    searched={searched}
                    />
            </Box>
            <Box sx={{ mt:0, width: { xs: "100%", sm: "100%", md: "100%", lg: "1500px" }, maxWidth: {md: "1300px"} }}>
                    <DataGrid
                        sx={{ height: 450, mt: 0,
                            "& .MuiDataGrid-columnHeaderTitle": {whiteSpace: "normal",lineHeight: "normal"},
                            "& .MuiDataGrid-columnHeader": {height: "unset !important"},
                            "& .MuiDataGrid-columnHeaders": {maxHeight: "168px !important"} ,
                            borderRadius:"0px 0px 10px 10px"
                        }}
                        columns={ searched ? searchedColums : defaultColumns}
                        columnVisibilityModel={hiddenColums}
                        onColumnVisibilityModelChange={(newHidden) => {
                            setHiddenColums(newHidden)
                        }}
                        rows={filteredOverview}
                        pageSize={50}
                        rowsPerPageOptions={[50]}
                        onRowClick={(params, event) => isO2maticUser ? null : goToInstallerDetails(params,event) }
                        loading={loading}
                        rowHeight={30}
                        components={{
                            NoRowsOverlay: () => (
                            <Stack height="100%" alignItems="center" justifyContent="center">
                                <Translate value="NoRowsPatients" />
                            { requestFailed.code !== 0 ? 
                                <>
                                    <br/>
                                    (<Translate value="ErrorCode" code={requestFailed.code}/>)
                                </>
                                :
                                <></>
                            }
                            </Stack>
                            ),
                            NoResultsOverlay: () => (
                                <Stack height="100%" alignItems="center" justifyContent="center">
                                <Translate value="NoResults" />
                                </Stack>
                            )
                        }}
                    />
                </Box>
        </PageContainer>
    )
}
